const globals = {
  GRAPHQL_ENDPOINT: process.env.REACT_APP_GRAPHQL_ENDPOINT as string,
  GRAPHQL_SUBSCRIPTION_ENDPOINT: process.env.REACT_APP_GRAPHQL_SUBSCRIPTION_ENDPOINT as string,
  timeout: 5000,
  pageSize: 10

}

export default globals